import { getAuthorizationHeader } from './oidc-auth-header';

type AuthHeaderProvider = () => string | undefined;

const AUTH_HEADER_PROVIDER_KEY = Symbol.for(
  '@terra/shared-utils/authHeaderProvider',
);

type AuthHeaderProviderHost = typeof globalThis & {
  [AUTH_HEADER_PROVIDER_KEY]?: AuthHeaderProvider | null;
};

const readProvider = (): AuthHeaderProvider | null => {
  const host = globalThis as AuthHeaderProviderHost;
  return host[AUTH_HEADER_PROVIDER_KEY] ?? null;
};

const writeProvider = (fn: AuthHeaderProvider | null): void => {
  const host = globalThis as AuthHeaderProviderHost;
  host[AUTH_HEADER_PROVIDER_KEY] = fn;
};

export function getTerraAuthHeader(): string | undefined {
  const provider = readProvider();
  return provider ? provider() : getAuthorizationHeader();
}

export function getTerraAuthHeaderProvider(): AuthHeaderProvider | null {
  return readProvider();
}

export function setTerraAuthHeaderProvider(
  fn: AuthHeaderProvider | null,
): void {
  writeProvider(fn);
}
